import Header from 'components/Header/Header';
import NavBar from 'components/NavBar';
import RightGif from 'components/RightGif';
import { SITE } from 'config/config';
import { twMerge } from 'tailwind-merge';

const MatchSchedule = () => {
  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover object-center"
      />
      <RightGif />
      <div className="container relative z-10 pb-[110px] md:pb-[32px] px-2">
        <Header />
        <div className="mx-auto max-w-[1280px] md:mt-2 bg-[#FFFFFF99] p-4 flex flex-col w-full md:pb-8 md:pt-4 rounded-2xl backdrop-blur-[48.53px]">
          <div className="flex items-center justify-center p-2">
            <img
              src="/assets/images/match/plan.png"
              alt="Lịch thi đấu hot"
              className="w-[96%] md:w-full max-w-[600px] h-auto max-h-[60px] object-contain"
            />
          </div>
          <div className="w-full h-auto min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
            <div className="p-3 border-none border-0">
              <iframe
                src="https://football-widget.pages.dev/"
                width="100%"
                height="600px"
                title="Football Widget"
                className="w-full border-0 border-none rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
      <NavBar />
    </div>
  );
};

export default MatchSchedule;
